import sdl from '@jds/react-generated-sdl/JDSCarouselPagination';
import type { JDSCarouselPaginationProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSCarouselPaginationProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { density = 'undefined', custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { density, ...rest },
    'JDSCarouselPagination',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const CarouselPagination = withLogic(
  Component
) as React.FC<JDSCarouselPaginationProps> & { slotName?: string };

CarouselPagination.displayName = 'CarouselPagination';
CarouselPagination.slotName = 'jds_carousel_pagination';

export { CarouselPagination, type JDSCarouselPaginationProps };
